import * as actionType from "./constants";

const initialState = {
    getSpaceTypeDataResponse: {},
    updateSpaceTypeResponse: { isLoading: false },
    addSpaceTypeResponse: { isLoading: false },
    deleteSpaceTypeResponse: { isLoading: false },
    getSpaceTypeLogsResponse: { isLoading: false },
    restoreSpaceTypeLogResponse: { isLoading: false },
    deleteSpaceTypeLogResponse: { isLoading: false },
    entityParams: {
        entity: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            list: null
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_SPACE_TYPE_DATA_REQUEST:
            return {
                ...state,
                getSpaceTypeDataResponse: { isLoading: true }
            };
        case actionType.GET_SPACE_TYPE_DATA_SUCCESS:
            return {
                ...state,
                getSpaceTypeDataResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.GET_SPACE_TYPE_DATA_FAILURE:
            return {
                ...state,
                getSpaceTypeDataResponse: { isLoading: false, success: false, ...action.error }
            };
        case actionType.UPDATE_SPACE_TYPE_REQUEST:
            return {
                ...state,
                updateSpaceTypeResponse: { isLoading: true }
            };
        case actionType.UPDATE_SPACE_TYPE_SUCCESS:
            return {
                ...state,
                updateSpaceTypeResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.UPDATE_SPACE_TYPE_FAILURE:
            return {
                ...state,
                updateSpaceTypeResponse: { isLoading: false, success: false, ...action.error }
            };

        case actionType.ADD_SPACE_TYPE_REQUEST:
            return {
                ...state,
                addSpaceTypeResponse: { isLoading: true }
            };
        case actionType.ADD_SPACE_TYPE_SUCCESS:
            return {
                ...state,
                addSpaceTypeResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.ADD_SPACE_TYPE_FAILURE:
            return {
                ...state,
                addSpaceTypeResponse: { isLoading: false, success: false, ...action.error }
            };
        case actionType.DELETE_SPACE_TYPE_REQUEST:
            return {
                ...state,
                deleteSpaceTypeResponse: { isLoading: true }
            };
        case actionType.DELETE_SPACE_TYPE_SUCCESS:
            return {
                ...state,
                deleteSpaceTypeResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.DELETE_SPACE_TYPE_FAILURE:
            return {
                ...state,
                deleteSpaceTypeResponse: { isLoading: false, success: false, ...action.error }
            };
        case actionType.UPDATE_SPACE_TYPE_ENTITY_PARAMS_SUCCESS:
            return {
                ...state,
                entityParams: { ...action.response }
            };
        case actionType.UPDATE_SPACE_TYPE_ENTITY_PARAMS_FAILURE:
            return {
                ...state,
                entityParams: { ...action.error }
            };

        case actionType.GET_SPACE_TYPE_LOGS_REQUEST:
            return {
                ...state,
                getSpaceTypeLogsResponse: { isLoading: true }
            };
        case actionType.GET_SPACE_TYPE_LOGS_SUCCESS:
            return {
                ...state,
                getSpaceTypeLogsResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.GET_SPACE_TYPE_LOGS_FAILURE:
            return {
                ...state,
                getSpaceTypeLogsResponse: { isLoading: false, success: false, ...action.error }
            };

        case actionType.RESTORE_SPACE_TYPE_LOG_REQUEST:
            return {
                ...state,
                restoreSpaceTypeLogResponse: { isLoading: true }
            };
        case actionType.RESTORE_SPACE_TYPE_LOG_SUCCESS:
            return {
                ...state,
                restoreSpaceTypeLogResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.RESTORE_SPACE_TYPE_LOG_FAILURE:
            return {
                ...state,
                restoreSpaceTypeLogResponse: { isLoading: false, success: false, ...action.error }
            };

        case actionType.DELETE_SPACE_TYPE_LOG_REQUEST:
            return {
                ...state,
                deleteSpaceTypeLogResponse: { isLoading: true }
            };
        case actionType.DELETE_SPACE_TYPE_LOG_SUCCESS:
            return {
                ...state,
                deleteSpaceTypeLogResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.DELETE_SPACE_TYPE_LOG_FAILURE:
            return {
                ...state,
                deleteSpaceTypeLogResponse: { isLoading: false, success: false, ...action.error }
            };

        default:
            return state;
    }
};
